import React from 'react';
import cx from 'classnames';

import { Close } from '../Icons';

interface TagProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  className?: string;
  logo?: React.ReactNode;
  inversed?: boolean;
  onClose?: () => void;
  size?: 'sm' | 'md';
}

const Tag = ({
  text,
  className,
  logo,
  size = 'sm',
  inversed = false,
  onClose,
  onClick,
  ...props
}: TagProps) => {
  return (
    <div
      className={cx(
        't-tag font-medium text-uta-black bg-pearl-grey md:hover:bg-primary',
        {
          'text-[10px] leading-[20px] h-[20px] px-[6px] gap-[6px]':
            size === 'sm',
          'text-[12px] leading-[30px] h-[30px] px-[10px] gap-[10px]':
            size === 'md',
          inversed: inversed,
        },
        className && className
      )}
      onClick={(e) => {
        const element = e.target as HTMLElement;
        if (element.tagName !== 'DIV') {
          e.preventDefault();
          return;
        }
        onClick && onClick(e);
      }}
      {...props}
    >
      {logo && logo}
      {text}
      {onClose && (
        <Close
          width={size === 'sm' ? 14 : 16}
          height={size === 'sm' ? 14 : 16}
          onClick={onClose}
          className="t-tag-close-icon"
        />
      )}
    </div>
  );
};

export default Tag;
